import { withTranslation } from "next-i18next";
import ProductImage from "@components/core/ProductImage";
import translateVariantSize from "@utils/translateVariantSize";

function ClosetItemValidationCard({ closetItem, t }) {
  const { product } = closetItem;
  return (
    <div className="w-100 d-flex align-items-center">
      <div
        style={{ minWidth: "32px", maxWidth: "32px", minHeight: "48px", maxHeight: "48px" }}
        className="bg-light position-relative"
      >
        <ProductImage
          src={product.main_picture_url}
          alt={product.name}
          className="w-100"
          sizes="64px"
        />
      </div>

      <p className="font-size-sm mb-0 text-gray drawer-closet-item-name mx-2">
        {closetItem.product.name}
      </p>

      <div
        style={{ minWidth: "100px", maxWidth: "100px" }}
        className="ms-auto"
      >
        <p className="font-size-sm text-gray mb-0">
          {t("common:variant_size", {
            size: translateVariantSize(
              closetItem.variant.size?.type,
              closetItem.variant.size?.value,
              t,
            ),
          })}
        </p>
      </div>
    </div>
  );
}

export default withTranslation("common")(ClosetItemValidationCard);
